import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { sandboxSlice } from './slices/sandbox';
import { dataSlice } from './slices/data';
import { newsletterSlice } from './slices/newsletter';
import { userClientsSlice } from './slices/userClients';
import { ebookSlice } from './slices/ebook';

const rootReducer = combineReducers({
  sandbox: sandboxSlice.reducer,
  data: dataSlice.reducer,
  newsletter: newsletterSlice.reducer,
  userClients: userClientsSlice.reducer,
  ebook: ebookSlice.reducer,
});

export default configureStore({
  reducer: rootReducer
});